
class EventManager {

    private deviceViewsRefreshListeners: deviceViewsRefreshListeners[] = [];
    private deviceSelectedListeners: DeviceSelectedListener[] = [];

    public addDeviceViewsRefreshListener(listener: deviceViewsRefreshListeners): void {
        if (this.deviceViewsRefreshListeners.indexOf(listener)>=0) {
            return;
        }
        this.deviceViewsRefreshListeners.push(listener);
    }

    public removeDeviceViewsRefreshListener(listener: deviceViewsRefreshListeners): void {
        let index = this.deviceViewsRefreshListeners.indexOf(listener);
        if (index < 0) {
            return;
        }
        this.deviceViewsRefreshListeners.splice(index, 1);
    }

    public notifyDeviceViewsRefresh(deviceViews: any[]): void {
        for(let listener of this.deviceViewsRefreshListeners) {
            listener(deviceViews);
        }
    }

    public addDeviceSelectedListener(listener: DeviceSelectedListener): void {
        if (this.deviceSelectedListeners.indexOf(listener)>=0) {
            return;
        }
        this.deviceSelectedListeners.push(listener);
    }

    public removeDeviceSelectedListener(listener: DeviceSelectedListener): void {
        let index = this.deviceSelectedListeners.indexOf(listener);
        if (index < 0) {
            return;
        }
        this.deviceSelectedListeners.splice(index, 1);
    }

    public notifyDeviceSelected(selectedDeviceView: any): void {
        for(let listener of this.deviceSelectedListeners) {
            listener(selectedDeviceView);
        }
    }
    

}

interface deviceViewsRefreshListeners {
    (deviceViews: any[]): void
}

interface DeviceSelectedListener {
    (deviceView: any): void
}

export default EventManager;
